export interface PaymentMethodClass {
    AccountPaymentMethodId: number
    AccountId: number
    PaymentMethod: string
    MasterPaymentMethodId: number
    IsDisabled: boolean
    AccountPaymentMethodGuidId: string
    IsDeleted: boolean
    isSelected:number
}

export const paymentMethodInitialsForAdd = {
    PaymentMethod: "",
    IsDisabled: false
}

export const paymentMethodInitialsForUpdate = {
    PaymentMethod: "",
    AccountPaymentMethodId: "",
    IsDisabled: false
}